export default __webpack_public_path__ + "/dist/images/setting-active.44dacdb66eae0f6e32afc3b1ff4d1ed1.svg";